<div class="card">
  <div class="card-body">
    <form [formGroup]="reminderForm" (ngSubmit)="onSubmit()">
      <div class="row">

        <!-- Reminder Title  -->
        <div class="col-md-3 mb-1">
          <label>Reminder Title <span style="color:var(--al-danger)">*</span></label>
          <input pInputText formControlName="title" class="form-control w-100" />
        </div>

        <!-- Date -->
        <div class="col-md-3 mb-1">
          <label>Reminder Date<span style="color:var(--al-danger)">*</span></label>
          <p-calendar class="w-100" formControlName="reminderDate" dateFormat="mm/dd/yy" [showTime]="false"
            [minDate]="minDate" appendTo="body">
          </p-calendar>
        </div>

        <!-- Time -->
        <div class="col-md-3 mb-1">
          <label>Reminder Time  <span style="color:var(--al-danger)">*</span></label>
          <p-calendar class="w-100" formControlName="reminderTime" [showTime]="true" [timeOnly]="true"
            hourFormat="24" [stepMinute]="15" appendTo="body" [readonlyInput]="true">
          </p-calendar>
        </div>

        <!-- Recurrence -->
        <div class="col-md-3 mb-1">
          <label>Reminder Recurrence <span style="color:var(--al-danger)">*</span></label>
          <p-dropdown class="w-100" formControlName="recurrenceType" [options]="recurrenceOptions"
            placeholder="None">
          </p-dropdown>
        </div>
        <!-- Date -->
        <div class="col-md-3 mb-1">
          <label>Reminder End Date</label>
          <p-calendar class="w-100" formControlName="reminderEndDate" dateFormat="mm/dd/yy" [showTime]="false"
            [minDate]="minDate" appendTo="body" [disabled]="reminderForm.get('reminderEndDate')?.disabled">
          </p-calendar>
        </div>

        <!-- Individuals to be Reminded  -->
        <div class="col-md-3 mb-1">
          <label >
            Individuals to be Reminded <span style="color:var(--al-danger)">*</span>

            <i class="mdi mdi-eye ml-2" [class.active-eye]="hasSelectedUsers"
              [style.color]="hasSelectedUsers ? 'var(--al-primary)' : 'var(--al-text-muted)'"
              [style.cursor]="hasSelectedUsers ? 'pointer' : 'not-allowed'"
              [title]="hasSelectedUsers ? 'View Selected Users' : 'No users selected'"
              (click)="showUsers()">
            </i>

            @if (hasSelectedUsers) {
              <span (click)="showUsers()" class="selected-count-badge">
                {{ reminderForm.get('recipientUserIds')?.value.length }}
              </span>
            }
          </label>
          <!-- v13-migration: [showClear]="true" [loading]="loadingUsers" removed — not inputs on PrimeNG 11 (inert no-ops); RESTORE at v16 when PrimeNG 16 adds them -->
          <p-multiSelect [maxSelectedLabels]="10000"  #multiSelect class="w-100" [options]="usersList" formControlName="recipientUserIds"
            optionLabel="mainEmail" optionValue="id" placeholder="Select" [filter]="true"
            appendTo="body" [emptyFilterMessage]="'No data found'"
            [emptyMessage]="'No data found'" (onHide)="onMultiSelectHide()">
          </p-multiSelect>
        </div>

        <!-- Reminder Notes  -->
        <div class="col-md-4 mb-1">
          <label>Reminder Notes <span style="color:var(--al-danger)">*</span></label>
          <textarea pInputTextarea formControlName="notes" rows="2" class="form-control w-100">
          </textarea>
        </div>

        <div class="col-md-2 d-flex align-items-center justify-content-end">
          <button pButton type="submit" [label]="editingReminder ? 'Update Reminder' : 'Create Reminder'"
            class="btn btn-primary" [disabled]="reminderForm.invalid">
          </button>

          @if (editingReminder) {
            <button type="button" class="btn btn-secondary ms-2" (click)="resetForm()">
              Cancel
            </button>
          }
        </div>

      </div>

    </form>
  </div>
</div>

<!-- Reminders Grid -->
<div class="card mt-4">
  <div class="card-body">
    <p-table [value]="reminders" [loading]="loadingReminders" [scrollable]="true"
      scrollHeight="400px">

      <ng-template pTemplate="header">
        <tr>
          <th>Reminder Title </th>
          <th>Reminder Notes </th>
          <th>Individuals to be Reminded </th>
          <th>Date & Time</th>
          <th>Recurrence</th>
          <th>End Date</th>
          <th >Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-reminder>
        <tr>
          <td>{{ reminder.title }}</td>
          <td>{{ reminder.notes }}</td>
          <td>
            <div class="recipients-cell">
              @for (id of reminder.recipientUserIds; track $index; let last = $last) {
                {{ getUserEmail(id) }}@if (!last) {
                <span>, </span>
              }
            }
          </div>
        </td>
        <td>{{ reminder.reminderDate | date:'MM/dd/yyyy HH:mm' }}</td>
        <td>{{ getReminderLabel(reminder.recurrenceType) || '-' }}</td>
        <td>{{ reminder.reminderEndDate | date:'MM/dd/yyyy HH:mm' }}</td>
        <td class="text-center">
          <!-- <button type="button" class="btn btn-success btn-sm me-1" title="Mark as Read"
          (click)="markAsRead(reminder)">
          <i class="mdi mdi-check"></i>
        </button> -->

        <button type="button" class="btn btn-info btn-sm me-1" title="Edit" (click)="onEdit(reminder)">
          <i class="mdi mdi-pencil"></i>
        </button>

        <button type="button" class="btn btn-danger btn-sm" title="Delete" (click)="onDelete(reminder)">
          <i class="mdi mdi-delete"></i>
        </button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6" class="text-center">
        No reminders found.
      </td>
    </tr>
  </ng-template>

</p-table>
</div>
</div>

<app-confirmation-alert [showAlert]="showDeleteConfirm" [message]="'Are you sure you want to delete this reminder?'"
  (response)="onDeleteConfirmed($event)">
</app-confirmation-alert>

<p-dialog
  [(visible)]="showUsersDialog"
  [header]="'Selected Individuals to be Reminded'+' ('+selectedUsers.length+')'"
  [modal]="true"
  [style]="{width: '550px'}"
  [closable]="true"
  (onHide)="showUsersDialog = false; selectedUsers = [];">
  <div class="p-3">
    @if (selectedUsers.length === 0) {
      <p class="text-center">No users selected.</p>
    }
    @if (selectedUsers.length > 0) {
      <p-listbox
        [options]="selectedUsers"
        optionLabel="mainEmail"
        [scrollHeight]="'350px'"
        [filter]="true" class="w-full md:w-56" >
      </p-listbox>
    }
  </div>
</p-dialog>